const ReactQueryKeys = {
    SERVICES: 'services',
};

export default ReactQueryKeys;
